import React, {Component} from "react"
import {withRouter, RouteComponentProps} from "react-router-dom"
import {LandingContainer} from "../landing-container/landing-container";
import {Helmet} from "react-helmet";
import ciblockLogo from "../img/CiBlock_logo.png";
import './ciblock-landing.css';


interface CiBlockLandingProps extends RouteComponentProps {}

export class CiBlockLanding extends Component<CiBlockLandingProps> {
    render() {
        return (
            <>
                <Helmet>
                    <title>CiBlock - GIS-платформа для градостроительного проектирования | Автоматизация проектирования микрорайонов</title>
                    <meta name="description" content="CiBlock - GIS-платформа для автоматизации проектирования микрорайонов. Планирование дорожной сети, расчет плотности застройки, AI-оптимизация инфраструктуры и выгрузка чертежей в AutoCAD. Сокращение затрат на проектирование."/>
                    <meta name="keywords" content="градостроительное проектирование, GIS платформа, проектирование микрорайонов, автоматизация проектирования, планирование дорожной сети, расчет плотности застройки, AutoCAD, DWG чертежи, оптимизация инфраструктуры, градостроительный анализ, кадастровый номер, проект планировки территории"/>

                    {/* Open Graph */}
                    <meta property="og:title" content="CiBlock - GIS-платформа для градостроительного проектирования"/>
                    <meta property="og:description" content="Автоматизация проектирования микрорайонов: планирование дорожной сети, расчет плотности, AI-оптимизация."/>
                    <meta property="og:type" content="website"/>
                    <meta property="og:url" content="https://www.labrahub.ru/#/ciblock"/>
                    <meta property="og:image" content="https://www.labrahub.ru/images/logos/CiBlock_logo.png"/>

                    {/* Twitter Card */}
                    <meta name="twitter:card" content="summary_large_image"/>
                    <meta name="twitter:title" content="CiBlock - GIS-платформа для градостроительного проектирования"/>
                    <meta name="twitter:description" content="Планирование дорожной сети, расчет плотности и AI-оптимизация инфраструктуры"/>
                    <meta name="twitter:image" content="https://www.labrahub.ru/images/logos/CiBlock_logo.png"/>
                </Helmet>
                <LandingContainer titleText={"CiBlock — GIS-платформа для градостроительного проектирования"} titleStyle={{'fontSize': 'xxx-large'}}>
                <div className="landing-section">
                    <div className="landing-section-content" style={{textAlign: 'center'}}>
                        <img src={ciblockLogo} style={{width: 400}}/>
                        <h3>Автоматизация проектирования микрорайонов с AI-оптимизацией</h3>
                        <p><b>CiBlock</b> — GIS-платформа для проектировщиков и градостроителей.
                        Планирование дорожной сети, расчет плотности застройки, оптимизация инфраструктуры
                        и выгрузка готовых DWG чертежей в AutoCAD.</p>
                        <div style={{ height: 10 }}/>
                        <p>Сокращайте время на проектирование до <b>40%</b> и затраты на разработку проектной документации.</p>
                    </div>
                </div>

                <div className="landing-section">
                    <div className="landing-section-content">
                        <h4>ВОЗМОЖНОСТИ CIBLOCK ДЛЯ ПРОЕКТИРОВЩИКОВ</h4>
                        <ul>
                            <li><b>Планирование дорожной сети</b> — автоматическая генерация сетки дорог с оптимизацией типов</li>
                            <li><b>Расчет плотности застройки</b> — автоматический подсчет показателей на основе зон и объектов</li>
                            <li><b>AI-оптимизация инфраструктуры</b> — алгоритмы для оптимального размещения объектов</li>
                            <li><b>Работа с кадастровыми данными</b> — импорт участков по координатам и кадастровым номерам</li>
                            <li><b>Выгрузка в AutoCAD</b> — экспорт готовых чертежей в привычном формате</li>
                            <li><b>Визуализация данных</b> — интерактивная карта с тепловой картой и метриками</li>
                        </ul>
                    </div>
                </div>

                <div className="landing-section">
                    <div className="landing-section-content">
                        <h4>ДЛЯ КОГО CIBLOCK</h4>
                        <div className="ciblock-targets">
                            <div className="target-card">
                                <h5>🏛️ Градостроители</h5>
                                <p>Проектирование микрорайонов с учетом всех нормативов и ограничений</p>
                            </div>
                            <div className="target-card">
                                <h5>📐 Проектные организации</h5>
                                <p>Автоматизация рутинных операций и сокращение сроков проектирования</p>
                            </div>
                            <div className="target-card">
                                <h5>🏗️ Застройщики</h5>
                                <p>Оценка эффективности планировочных решений и оптимизация инфраструктуры</p>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="landing-section">
                    <div className="landing-section-content">
                        <h4>КАК РАБОТАЕТ CIBLOCK</h4>
                        <ol>
                            <li>Загрузите границы участка по координатам или кадастровому номеру</li>
                            <li>Спланируйте дорожную сеть с помощью генераторов или вручную</li>
                            <li>Разместите зоны и объекты с автоматическим расчетом показателей</li>
                            <li>Примените AI-оптимизацию для улучшения планировочного решения</li>
                            <li>Выгрузите готовый чертеж в AutoCAD с слоями и форматированием</li>
                        </ol>
                    </div>
                </div>

                <div className="landing-section ciblock-cta">
                    <div className="landing-section-content" style={{textAlign: 'center'}}>
                        <h3>Начните упрощать проектирование уже сегодня</h3>
                        <p>Попробуйте CiBlock бесплатно и оцените эффективность автоматизации</p>
                        <button className="cta-button" onClick={() => window.location.href = '#/ciblock/map'}>
                            Попробовать CiBlock
                        </button>
                    </div>
                </div>
            </LandingContainer>
            </>
        )
    };
}

export default withRouter(CiBlockLanding);
